"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var badges_module_scss_1 = __importDefault(require("./badges.module.scss"));
var Badges = function (props) {
    var _a = props.badges, discount = _a.discount, novelty = _a.novelty, popularity = _a.popularity, quality = _a.quality, certified = _a.certified;
    return (react_1.default.createElement("div", { className: badges_module_scss_1.default.root },
        discount !== 0 && (react_1.default.createElement("span", { className: badges_module_scss_1.default.badge },
            "\u0421\u043A\u0438\u0434\u043A\u0430 ",
            discount,
            "%")),
        novelty && react_1.default.createElement("span", { className: badges_module_scss_1.default.badge }, "\u041D\u043E\u0432\u0438\u043D\u043A\u0430"),
        quality && react_1.default.createElement("span", { className: badges_module_scss_1.default.badge }, "\u041A\u0430\u0447\u0435\u0441\u0442\u0432\u043E"),
        popularity !== 0 && (react_1.default.createElement("div", { className: badges_module_scss_1.default.hit },
            react_1.default.createElement("span", { className: badges_module_scss_1.default.badge }, "\u0425\u0438\u0442"),
            react_1.default.createElement("div", { className: badges_module_scss_1.default.views },
                react_1.default.createElement("span", { className: badges_module_scss_1.default.viewsIcon }),
                react_1.default.createElement("span", { className: badges_module_scss_1.default.viewsCount }, popularity)))),
        certified && react_1.default.createElement("span", { className: badges_module_scss_1.default.badge }, "\u0410\u043D\u0442\u0438\u0432\u0438\u0440\u0443\u0441")));
};
exports.default = Badges;
